import * as api from '../../../api/stock/stockApi';
import {
  FETCH_STOCKS_REQUEST,
  FETCH_STOCKS_SUCCESS,
  FETCH_STOCKS_FAILURE,
  CREATE_STOCK,
  UPDATE_STOCK,
  DELETE_STOCK
} from '../../types/stock/stockTypes';

export const fetchStocks = () => async (dispatch) => {
  dispatch({ type: FETCH_STOCKS_REQUEST });
  try {
    const response = await api.fetchStocks();
    dispatch({ type: FETCH_STOCKS_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch stocks';
    dispatch({ type: FETCH_STOCKS_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createStock = (data) => async (dispatch) => {
  try {
    const response = await api.createStock(data);
    const newStock = { id: response.data.id, ...response.data.data };
    dispatch({ type: CREATE_STOCK, payload: newStock });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create stock';
    throw new Error(errorMessage);
  }
};

export const updateStock = (id, data) => async (dispatch) => {
  try {
    const response = await api.updateStock(id, data);
    dispatch({ type: UPDATE_STOCK, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update stock';
    throw new Error(errorMessage);
  }
};

export const deleteStock = (id) => async (dispatch) => {
  try {
    const response = await api.deleteStock(id);
    dispatch({ type: DELETE_STOCK, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete stock';
    throw new Error(errorMessage);
  }
};
